/**
 * SectionGroupHeading – subdued group label for editorial workspace layout.
 */
interface Props {
  title: string;
  subtitle?: string;
  badge?: string;
}

export function SectionGroupHeading({ title, subtitle, badge }: Props) {
  return (
    <div className="pt-2 pb-1">
      <div className="flex items-center gap-2">
        <h2 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {title}
        </h2>
        {badge && (
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent/50 text-accent-foreground font-medium">
            {badge}
          </span>
        )}
      </div>
      {subtitle && (
        <p className="text-[11px] text-muted-foreground/70 mt-0.5">{subtitle}</p>
      )}
    </div>
  );
}
